export interface PendingClient {
    first_name?: string;
    last_name?: string;

    email?: string;
    phone_number?: string;

    company?: string;
    company_address?: string;

    industry_type?: string;
    gstin?: string;

    status?: string;
}

export interface PendingDeleteClient {
    awaitingName?: boolean;
}

export const startCreateClientFlow = (
    setPendingClient: (data: PendingClient | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPendingClient({});
    pushAIChat("Sure! Let's create a new client. What is the first name?");
    speak("What is the first name?");
};

export const processPendingClient = (
    text: string,
    pending: PendingClient,
    setPendingClient: (data: PendingClient | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // 1️⃣ First Name
    if (!pending.first_name) {
        setPendingClient({ ...pending, first_name: text });
        pushAIChat("What is the last name?");
        speak("What is the last name?");
        return;
    }

    // 2️⃣ Last Name
    if (!pending.last_name) {
        setPendingClient({ ...pending, last_name: text });
        pushAIChat("What is the email address?");
        speak("What is the email address?");
        return;
    }

    // 3️⃣ Email
    if (!pending.email) {
        setPendingClient({ ...pending, email: text });
        pushAIChat("What is the phone number?");
        speak("What is the phone number?");
        return;
    }

    // 4️⃣ Phone Number
    if (!pending.phone_number) {
        setPendingClient({ ...pending, phone_number: text });
        pushAIChat("What is the company name?");
        speak("What is the company name?");
        return;
    }

    // 5️⃣ Company
    if (!pending.company) {
        setPendingClient({ ...pending, company: text });
        pushAIChat("What is the company address?");
        speak("What is the company address?");
        return;
    }

    // 6️⃣ Company Address
    if (!pending.company_address) {
        setPendingClient({ ...pending, company_address: text });
        pushAIChat("What is the industry type?");
        speak("What is the industry type?");
        return;
    }

    // 7️⃣ Industry Type
    if (!pending.industry_type) {
        setPendingClient({ ...pending, industry_type: text });
        finalizeClient(
            { ...pending, industry_type: text },
            setPendingClient,
            pushAIChat,
            speak
        );
    }
};

const finalizeClient = (
    pending: PendingClient,
    setPendingClient: (data: PendingClient | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    pushAIChat("Creating client now...");
    speak("Creating client now.");

    window.dispatchEvent(
        new CustomEvent("ai-create-client", {
            detail: {
                first_name: pending.first_name,
                last_name: pending.last_name,
                email: pending.email,
                phone_number: pending.phone_number,
                company: pending.company,
                company_address: pending.company_address,
                industry_type: pending.industry_type,
                gstin: pending.gstin,
                status: pending.status || "active"
            }
        })
    );

    setPendingClient(null);
};

export const startDeleteClientFlow = (
    setPendingDelete: (data: PendingDeleteClient | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        pushAIChat(`Deleting client "${nameFromIntent}"...`);
        speak(`Deleting client ${nameFromIntent}`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-client", {
                detail: { name: nameFromIntent }
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which client should be deleted?");
    speak("Which client should be deleted?");
};

export const processPendingDeleteClient = (
    text: string,
    pending: PendingDeleteClient,
    setPendingDelete: (data: PendingDeleteClient | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    const cleanName = text.replace(/[^a-zA-Z0-9 ]/g, "").trim();

    if (!cleanName) {
        pushAIChat("Please provide a valid client name.");
        speak("Please provide a valid client name.");
        return;
    }

    pushAIChat(`Deleting client "${cleanName}"...`);
    speak(`Deleting client ${cleanName}`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-client", {
            detail: { name: cleanName }
        })
    );

    setPendingDelete(null);
};

